(function () {
  var STORE_PREFIX = 'tk-pc:';

  var isHistoryRestore = (function () {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      if (entry && entry.type) return entry.type === 'back_forward';
    } catch (e) {}
    try {
      return !!performance.navigation && performance.navigation.type === 2;
    } catch (e) {}
    return false;
  })();

  function storageKey(root) {
    var all = document.querySelectorAll('[data-tk-pc-root]');
    var idx = Array.prototype.indexOf.call(all, root);
    return STORE_PREFIX + location.pathname + ':' + (root.id || 'pc') + ':' + idx;
  }

  function readIndex(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (raw == null) return null;
      var n = parseInt(raw, 10);
      return isNaN(n) ? null : n;
    } catch (e) {
      return null;
    }
  }

  function writeIndex(key, value) {
    try { sessionStorage.setItem(key, String(value)); } catch (e) {}
  }

  function initCarousel(root) {
    if (!root || root.dataset.tkPcInit === '1') return;
    root.dataset.tkPcInit = '1';

    var scrollEl = root.querySelector('[data-tk-pc-scroll]');
    if (!scrollEl) return;
    var prevBtn = root.querySelector('[data-tk-pc-prev]');
    var nextBtn = root.querySelector('[data-tk-pc-next]');
    var dotsEl = root.querySelector('[data-tk-pc-dots]');
    var trackEl = scrollEl.querySelector('.tk-product-carousel__track');

    var realItems = trackEl ? Array.prototype.slice.call(trackEl.children) : [];
    var realCount = realItems.length;
    var loopBuilt = false;
    var loopWanted = false;
    var padCount = 0;
    var padWidth = 0;
    var setWidth = 0;
    var normalizeTimer = null;
    var prevHideTimer = null;

    var isDown = false, startX = 0, scrollStart = 0, hasMoved = false, activePointer = null;
    var targetScroll = 0, curScroll = 0, rafId = null, samples = [], snapPrev = null;

    var storeKey = storageKey(root);
    var restoreIndex = isHistoryRestore ? readIndex(storeKey) : null;
    if (!isHistoryRestore) {
      try { sessionStorage.removeItem(storeKey); } catch (e) {}
    }

    var userInteracted = false;
    function markInteracted() {
      userInteracted = true;
      loopWanted = true;
      ensureLoop();
    }
    scrollEl.addEventListener('pointerdown', markInteracted, { passive: true });
    scrollEl.addEventListener('touchstart', markInteracted, { passive: true });
    scrollEl.addEventListener('wheel', markInteracted, { passive: true });
    scrollEl.addEventListener('keydown', markInteracted, { passive: true });

    var maxCache = -1;

    function maxScroll() {
      if (maxCache < 0) maxCache = scrollEl.scrollWidth - scrollEl.clientWidth;
      return maxCache;
    }

    function resetMax() { maxCache = -1; }

    var stepCache = 0;

    function itemStep() {
      if (stepCache) return stepCache;
      var first = trackEl && trackEl.children[0];
      var iw = first ? first.getBoundingClientRect().width : scrollEl.clientWidth;
      var gap = trackEl ? (parseFloat(getComputedStyle(trackEl).columnGap || getComputedStyle(trackEl).gap || '0') || 0) : 0;
      var step = iw + gap;
      if (iw > 0) stepCache = step;
      return step;
    }

    function resetStep() { stepCache = 0; resetMax(); }

    function perView() {
      var step = itemStep() || scrollEl.clientWidth;
      return Math.max(1, Math.round(scrollEl.clientWidth / step));
    }

    function setScroll(value) {
      var prev = scrollEl.style.scrollBehavior;
      scrollEl.style.scrollBehavior = 'auto';
      scrollEl.scrollLeft = value;
      scrollEl.style.scrollBehavior = prev;
      curScroll = scrollEl.scrollLeft;
      if (!isDown) targetScroll = curScroll;
    }

    function neededPad() {
      var step = itemStep();
      if (!step) return 0;
      return Math.min(16, Math.ceil((scrollEl.clientWidth * 1.2) / step) + 1);
    }

    function cloneItem(index) {
      var src = realItems[((index % realCount) + realCount) % realCount];
      var clone = src.cloneNode(true);
      clone.setAttribute('data-tk-pc-clone', '');
      var flagged = clone.querySelectorAll('[data-tk-swatch-init], [data-tk-variant-fix]');
      for (var i = 0; i < flagged.length; i++) {
        flagged[i].removeAttribute('data-tk-swatch-init');
        flagged[i].removeAttribute('data-tk-variant-fix');
      }
      // Klon ma stejnou URL obrazku jako original, takze jde o zasah do cache.
      // S lazy by se dotahoval az pod prstem a karta by pri swipu probliknula.
      var imgs = clone.querySelectorAll('img[loading="lazy"]');
      for (var j = 0; j < imgs.length; j++) imgs[j].loading = 'eager';
      return clone;
    }

    function dropClones() {
      var clones = trackEl.querySelectorAll('[data-tk-pc-clone]');
      for (var i = 0; i < clones.length; i++) clones[i].parentNode.removeChild(clones[i]);
      resetMax();
    }

    function buildLoop() {
      if (loopBuilt || !trackEl) return;
      resetStep();
      if (maxScroll() <= 8) return;
      realItems = Array.prototype.slice.call(trackEl.children);
      realCount = realItems.length;
      if (realCount < 2) return;
      var pad = neededPad();
      if (!pad) return;

      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      for (var i = 0; i < pad; i++) {
        before.appendChild(cloneItem(realCount - pad + i));
        after.appendChild(cloneItem(i));
      }

      var prev = scrollEl.scrollLeft;
      trackEl.appendChild(after);
      trackEl.insertBefore(before, realItems[0]);
      resetMax();

      var firstTail = trackEl.children[pad + realCount];
      padWidth = realItems[0].offsetLeft - trackEl.children[0].offsetLeft;
      setWidth = firstTail ? firstTail.offsetLeft - realItems[0].offsetLeft : 0;

      if (padWidth <= 0 || setWidth <= 0) {
        dropClones();
        padWidth = 0;
        setWidth = 0;
        return;
      }

      padCount = pad;
      loopBuilt = true;
      setScroll(prev + padWidth);
      buildDots();
      updateDots();
      updateNav(true);
    }

    function teardownLoop() {
      if (!loopBuilt) return;
      normalize();
      var offset = scrollEl.scrollLeft - padWidth;
      dropClones();
      resetStep();
      loopBuilt = false;
      padCount = 0;
      padWidth = 0;
      setWidth = 0;
      setScroll(Math.max(0, Math.min(offset, maxScroll())));
    }

    function ensureLoop() {
      if (!loopBuilt) buildLoop();
    }

    function normalize() {
      if (!loopBuilt || setWidth <= 0) return;
      var p = scrollEl.scrollLeft;
      var rel = p - padWidth;
      if (rel >= 0 && rel < setWidth) return;
      var shift = Math.floor(rel / setWidth) * setWidth;
      if (!shift) return;
      setScroll(p - shift);
      updateDots();
    }

    function scheduleNormalize() {
      if (!loopBuilt || isDown) return;
      if (normalizeTimer) clearTimeout(normalizeTimer);
      normalizeTimer = setTimeout(function () {
        if (!isDown) normalize();
      }, 140);
      var edge = itemStep();
      var p = scrollEl.scrollLeft;
      if (p < edge || p > maxScroll() - edge) normalize();
    }

    function positionFor(index) {
      var base = loopBuilt ? padWidth : 0;
      if (!index || index < 0) return base;
      var step = itemStep();
      if (!step) return base;
      if (loopBuilt) return base + index * step;
      return Math.min(index * step, Math.max(0, maxScroll()));
    }

    function applyStoredPosition() {
      if (userInteracted) return;
      var target = positionFor(restoreIndex);
      if (Math.abs(scrollEl.scrollLeft - target) > 1) setScroll(target);
    }

    applyStoredPosition();
    requestAnimationFrame(applyStoredPosition);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(applyStoredPosition);
    setTimeout(applyStoredPosition, 300);
    setTimeout(applyStoredPosition, 800);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', applyStoredPosition, { once: true });
    }

    var saveTimer = null;
    function saveIndex() {
      var step = itemStep();
      if (!step) { writeIndex(storeKey, 0); return; }
      var idx = Math.round((scrollEl.scrollLeft - (loopBuilt ? padWidth : 0)) / step);
      if (loopBuilt && realCount) idx = ((idx % realCount) + realCount) % realCount;
      writeIndex(storeKey, Math.max(0, idx));
    }
    window.addEventListener('pagehide', saveIndex);

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var stored = readIndex(storeKey);
      if (stored == null) return;
      var target = positionFor(stored);
      if (Math.abs(scrollEl.scrollLeft - target) > 1) setScroll(target);
    });

    function atLoopStart() {
      if (!loopBuilt || setWidth <= 0) return false;
      var rel = (((scrollEl.scrollLeft - padWidth) % setWidth) + setWidth) % setWidth;
      return rel < 8 || rel > setWidth - 8;
    }

    function updatePrevVisibility(immediate) {
      if (!atLoopStart()) {
        if (prevHideTimer) { clearTimeout(prevHideTimer); prevHideTimer = null; }
        if (prevBtn.hasAttribute('hidden')) prevBtn.removeAttribute('hidden');
        return;
      }
      if (immediate) {
        prevBtn.setAttribute('hidden', '');
        return;
      }
      if (prevHideTimer) return;
      prevHideTimer = setTimeout(function () {
        prevHideTimer = null;
        if (atLoopStart()) prevBtn.setAttribute('hidden', '');
      }, 200);
    }

    var navState = '';

    function updateNav(immediate) {
      if (!prevBtn || !nextBtn) return;
      if (loopBuilt) {
        navState = '';
        prevBtn.removeAttribute('disabled');
        nextBtn.removeAttribute('disabled');
        updatePrevVisibility(immediate);
        return;
      }
      var sl = scrollEl.scrollLeft;
      var limit = maxScroll();
      var state;
      if (limit <= 2) state = 'none';
      else if (sl <= 10) state = 'start';
      else if (sl >= limit - 10) state = 'end';
      else state = 'mid';
      if (state === navState) return;
      navState = state;
      if (state === 'none') {
        prevBtn.setAttribute('disabled', '');
        prevBtn.setAttribute('hidden', '');
        nextBtn.setAttribute('disabled', '');
        return;
      }
      if (state === 'start') {
        prevBtn.setAttribute('disabled', '');
        prevBtn.setAttribute('hidden', '');
      } else {
        prevBtn.removeAttribute('disabled');
        prevBtn.removeAttribute('hidden');
      }
      if (state === 'end') nextBtn.setAttribute('disabled', '');
      else nextBtn.removeAttribute('disabled');
    }

    // Jeden posluchac na snimek. Ctyri samostatne se pri flingu poustely nekolikrat
    // za snimek a kazdy si sahal na scrollLeft.
    var scrollRaf = null;
    var lastScrollLeft = -1;
    scrollEl.addEventListener('scroll', function () {
      if (scrollRaf != null) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        if (scrollEl.scrollLeft === lastScrollLeft) return;
        lastScrollLeft = scrollEl.scrollLeft;
        updateNav();
        updateDots();
        scheduleNormalize();
        if (saveTimer) clearTimeout(saveTimer);
        saveTimer = setTimeout(saveIndex, 150);
      });
    }, { passive: true });

    function smoothScroll(distance) {
      if (loopBuilt && setWidth > 0) {
        normalize();
        var target = scrollEl.scrollLeft + distance;
        var limit = maxScroll();
        var guard = 0;
        while (target > limit && guard++ < 20) {
          setScroll(scrollEl.scrollLeft - setWidth);
          target -= setWidth;
        }
        while (target < 0 && guard++ < 20) {
          setScroll(scrollEl.scrollLeft + setWidth);
          target += setWidth;
        }
      }
      scrollEl.style.scrollBehavior = 'smooth';
      scrollEl.scrollBy({ left: distance });
      setTimeout(function () { scrollEl.style.scrollBehavior = 'auto'; }, 400);
    }

    // Skok musi byt cely nasobek karty, jinak po plynulem scrollu dojede jeste
    // snap a je z toho druhy skok.
    function pageDistance() {
      var step = itemStep();
      if (!step) return scrollEl.clientWidth;
      var fits = Math.floor((scrollEl.clientWidth * 0.9) / step);
      return Math.max(1, fits) * step;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      markInteracted();
      smoothScroll(-pageDistance());
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      markInteracted();
      smoothScroll(pageDistance());
    });

    function dotCount() {
      if (!trackEl) return 0;
      if (loopBuilt) return realCount;
      return Math.max(1, realCount - perView() + 1);
    }

    function goToDot(idx) {
      var step = itemStep();
      if (loopBuilt && setWidth > 0) {
        normalize();
        var delta = idx * step - (scrollEl.scrollLeft - padWidth);
        delta -= Math.round(delta / setWidth) * setWidth;
        smoothScroll(delta);
        return;
      }
      scrollEl.style.scrollBehavior = 'smooth';
      scrollEl.scrollTo({ left: idx * step });
      setTimeout(function () { scrollEl.style.scrollBehavior = 'auto'; }, 400);
    }

    function buildDots() {
      if (!dotsEl || !trackEl) return;
      var count = dotCount();
      var fits = realCount <= perView();
      if (dotsEl.children.length === count && dotsEl.dataset.tkPcFits === String(fits)) return;
      dotsEl.innerHTML = '';
      activeDot = -1;
      for (var i = 0; i < count; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', ((window.tkI18n && window.tkI18n.carousel_page) || 'Page') + ' ' + (i + 1));
        (function (idx) {
          b.addEventListener('click', function () {
            markInteracted();
            goToDot(idx);
          });
        })(i);
        dotsEl.appendChild(b);
      }
      dotsEl.dataset.tkPcFits = String(fits);
      dotsEl.style.display = count <= 1 || fits ? 'none' : '';
    }

    var activeDot = -1;

    function updateDots() {
      if (!dotsEl || !dotsEl.children.length) return;
      var step = itemStep();
      var sl = scrollEl.scrollLeft;
      var last = dotsEl.children.length - 1;
      var idx;
      if (loopBuilt && setWidth > 0) {
        idx = step > 0 ? Math.round((sl - padWidth) / step) : 0;
        idx = ((idx % realCount) + realCount) % realCount;
      } else {
        var max = maxScroll();
        if (max <= 0 || sl <= 4) {
          idx = 0;
        } else if (sl >= max - 4) {
          idx = last;
        } else {
          idx = step > 0 ? Math.round(sl / step) : 0;
        }
        idx = Math.max(0, Math.min(idx, last));
      }
      if (idx === activeDot) return;
      activeDot = idx;
      for (var i = 0; i < dotsEl.children.length; i++) {
        if (i === idx) dotsEl.children[i].setAttribute('aria-current', 'true');
        else dotsEl.children[i].removeAttribute('aria-current');
      }
    }
    buildDots();
    updateDots();
    window.addEventListener('resize', function () {
      resetStep();
      if (loopBuilt) {
        if (padCount < neededPad()) { teardownLoop(); buildLoop(); }
      } else if (loopWanted) {
        buildLoop();
      }
      buildDots();
      updateDots();
      updateNav();
    }, { passive: true });

    function shiftLoop(delta) {
      var p = scrollEl.scrollLeft + delta;
      targetScroll += delta;
      scrollStart += delta;
      curScroll = p;
      scrollEl.scrollLeft = p;
    }

    function clampTarget() {
      if (loopBuilt && setWidth > 0) {
        var guard = 0;
        while (targetScroll - padWidth >= setWidth && guard++ < 40) shiftLoop(-setWidth);
        while (targetScroll - padWidth < 0 && guard++ < 40) shiftLoop(setWidth);
        return;
      }
      var m = maxScroll();
      if (targetScroll < 0) targetScroll = 0;
      else if (targetScroll > m) targetScroll = m;
    }

    function endGesture() {
      if (snapPrev !== null) { scrollEl.style.scrollSnapType = snapPrev; snapPrev = null; }
      updateNav();
      updateDots();
    }

    // Dojezd musi viset na case, ne na snimcich. S pevnym krokem na snimek
    // dobehne na 240 Hz ctyrikrat driv nez na 60 Hz a misto klouzani je z toho skok.
    var rafLast = 0;

    function rafTick(ts) {
      var now = ts || (window.performance && performance.now()) || Date.now();
      var dt = rafLast ? Math.min(64, now - rafLast) : 16.7;
      rafLast = now;
      var diff = targetScroll - curScroll;
      curScroll += isDown ? diff : diff * (1 - Math.pow(0.78, dt / 16.6667));
      if (Math.abs(targetScroll - curScroll) < 0.5) curScroll = targetScroll;
      scrollEl.scrollLeft = curScroll;
      if (curScroll !== targetScroll) {
        rafId = requestAnimationFrame(rafTick);
      } else {
        rafId = null;
        rafLast = 0;
        if (!isDown) endGesture();
      }
    }

    function ensureRaf() {
      if (rafId == null) {
        rafLast = 0;
        rafId = requestAnimationFrame(rafTick);
      }
    }

    function onPointerDown(e) {
      if (e.pointerType === 'touch') return;
      if (e.button && e.button !== 0) return;
      isDown = true; hasMoved = false; activePointer = e.pointerId;
      startX = e.clientX;
      scrollStart = scrollEl.scrollLeft;
      curScroll = scrollEl.scrollLeft;
      targetScroll = curScroll;
      samples = [{ x: e.clientX, t: Date.now() }];
      snapPrev = null;
      if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; }
    }

    function onPointerMove(e) {
      if (!isDown || e.pointerId !== activePointer) return;
      var diff = e.clientX - startX;
      if (!hasMoved) {
        if (Math.abs(diff) <= 6) return;
        hasMoved = true;
        scrollEl.classList.add('is-dragging');
        snapPrev = scrollEl.style.scrollSnapType || '';
        scrollEl.style.scrollSnapType = 'none';
        try { scrollEl.setPointerCapture(activePointer); } catch (err) {}
      }
      if (e.cancelable) e.preventDefault();
      targetScroll = scrollStart - diff;
      clampTarget();
      var now = Date.now();
      samples.push({ x: e.clientX, t: now });
      while (samples.length > 2 && now - samples[0].t > 90) samples.shift();
      ensureRaf();
    }

    function onPointerUp(e) {
      if (!isDown || (e && e.pointerId !== activePointer)) return;
      isDown = false;
      var pid = activePointer; activePointer = null;
      scrollEl.classList.remove('is-dragging');
      try { if (pid != null) scrollEl.releasePointerCapture(pid); } catch (err) {}
      if (!hasMoved) { endGesture(); return; }

      var v = 0;
      if (samples.length >= 2) {
        var a = samples[0], b = samples[samples.length - 1];
        var dt = b.t - a.t;
        if (dt > 0) v = (b.x - a.x) / dt;
      }
      var projected = scrollEl.scrollLeft - v * 220;
      var step = itemStep();
      targetScroll = step > 0 ? Math.round(projected / step) * step : projected;
      clampTarget();
      curScroll = scrollEl.scrollLeft;
      ensureRaf();
      if (rafId == null) endGesture();
    }

    scrollEl.addEventListener('pointerdown', onPointerDown);
    scrollEl.addEventListener('pointermove', onPointerMove);
    scrollEl.addEventListener('pointerup', onPointerUp);
    scrollEl.addEventListener('pointercancel', onPointerUp);
    scrollEl.addEventListener('lostpointercapture', onPointerUp);
    scrollEl.addEventListener('dragstart', function (e) { e.preventDefault(); });
    scrollEl.addEventListener('click', function (e) {
      if (hasMoved) { e.preventDefault(); e.stopPropagation(); }
      hasMoved = false;
    }, true);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          loopWanted = true;
          io.disconnect();
          // Klonovani karet je drahe, at nepadne do snimku tesne pred prvnim swipem.
          if (window.requestIdleCallback) requestIdleCallback(ensureLoop, { timeout: 1200 });
          else ensureLoop();
          return;
        }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else {
      loopWanted = true;
      ensureLoop();
    }

    var autoMs = parseInt(root.getAttribute('data-tk-pc-autoplay') || '0', 10);
    if (autoMs > 0 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var autoTimer = null;
      var autoHold = 0;
      var autoVisible = false;

      function autoStop() {
        if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
      }

      function autoTick() {
        autoTimer = null;
        if (autoHold || document.hidden || !autoVisible || isDown) { autoStart(); return; }
        loopWanted = true;
        ensureLoop();
        var step = itemStep();
        smoothScroll(step || pageDistance());
        autoStart();
      }

      function autoStart() {
        autoStop();
        autoTimer = setTimeout(autoTick, autoMs);
      }

      function autoHoldOn() { autoHold++; autoStop(); }
      function autoHoldOff() {
        autoHold = Math.max(0, autoHold - 1);
        if (!autoHold) autoStart();
      }

      root.addEventListener('mouseenter', autoHoldOn);
      root.addEventListener('mouseleave', autoHoldOff);
      root.addEventListener('focusin', autoHoldOn);
      root.addEventListener('focusout', autoHoldOff);
      scrollEl.addEventListener('pointerdown', autoStop, { passive: true });
      scrollEl.addEventListener('touchstart', autoStop, { passive: true });
      scrollEl.addEventListener('pointerup', function () { if (!autoHold) autoStart(); });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) autoStop();
        else if (!autoHold) autoStart();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          autoVisible = entries[0].isIntersecting;
          if (autoVisible) { if (!autoHold) autoStart(); }
          else autoStop();
        }, { threshold: 0.2 }).observe(root);
      } else {
        autoVisible = true;
        autoStart();
      }
    }

    updateNav();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-tk-pc-root]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initAll();

    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-tk-pc-root]')) {
            initCarousel(node);
          } else if (node.querySelector) {
            initAll(node);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
